<section class="cmn-innerpage-wrapper quotation">
  <div class="main-wrapper">
    <div class="head-container">
      <div class="flex-wrapper">
        <div class="leftContainer">
          <div>
            <h6>Order Code</h6>
            <h5>{{ orderData?.orderCode || "--" }}</h5>
          </div>
          <div>
            <h6>Customer Name</h6>
            <h5>
              {{
                orderData?.customerData
                  ? orderData?.customerData?.firstName +
                    " " +
                    orderData?.customerData?.lastName
                  : "--"
              }}
            </h5>
          </div>
          <div>
            <h6>Quote Id</h6>
            <h5>{{ orderData?.quoteData?.quoteCode || "--" }}</h5>
          </div>
          <div>
            <h6>Total Amount</h6>
            <!-- <h5>AED {{ orderData?.totalAmount | number : "1.2-2" }}</h5> -->
            <h5>AED XXX</h5>
          </div>
          <div>
            <h6>Balance</h6>
            <!-- <h5>AED {{ orderData?.balance | number : "1.2-2" }}</h5> -->
            <h5>AED XXX</h5>
          </div>
        </div>
        <div class="rightContainer">
          <div class="statusWrapper">
            <h6>
              Expected Date :
              <span class="">
                &nbsp; {{ orderData?.orderDate | date : "dd/MM/yyyy" }}</span
              >
            </h6>
            <h6>
              Status :
              <span class="status-inProgress">
                &nbsp; {{ orderData?.status || "--" }}</span
              >
            </h6>
            <h6>
              Priority :
              <span class="P-High">
                &nbsp; {{ orderData?.priority || "--" }}</span
              >
            </h6>
          </div>
          <div class="actionWrapper">
            <!-- <div [matMenuTriggerFor]="menuHead" #menuTrigger>
              <mat-menu #menuHead="matMenu">
                <button mat-menu-item>option one</button>
                <button mat-menu-item>option two</button>
                <button mat-menu-item>option three</button>
              </mat-menu>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="23"
                viewBox="0 0 4 23"
                fill="none"
              >
                <g opacity="0.6">
                  <circle cx="2" cy="2" r="2" fill="black" />
                  <circle cx="2" cy="11.3333" r="2" fill="black" />
                  <circle cx="2" cy="20.6667" r="2" fill="black" />
                </g>
              </svg>
            </div> -->

            <div
              (click)="openDialog()"
              *ngIf="canListTimelineOrderFlow$ | async"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
              >
                <g clip-path="url(#clip0_12_2730)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M25.0729 14.5C25.0779 16.8623 24.287 19.1575 22.8278 21.0153L21.1458 19.3333L19.9375 20.5417V25.9792H25.375L26.5833 24.7708L24.9763 23.1638C26.9961 20.729 28.0991 17.6635 28.0938 14.5C28.0938 6.99263 22.0074 0.90625 14.5 0.90625C6.99263 0.90625 0.90625 6.99263 0.90625 14.5C0.90625 22.0074 6.99263 28.0938 14.5 28.0938C15.4304 28.0921 16.3363 28.0015 17.2175 27.8219L16.6158 24.8615C14.4781 25.2981 12.2577 25.0627 10.2591 24.1875C8.26047 23.3124 6.58155 21.8403 5.45258 19.9733C4.32361 18.1063 3.79988 15.9357 3.95323 13.7593C4.10658 11.5829 4.92949 9.50718 6.3091 7.81691C7.68872 6.12665 9.55746 4.90458 11.659 4.31832C13.7606 3.73206 15.9921 3.81033 18.0475 4.54238C20.1028 5.27443 21.8813 6.62441 23.1391 8.40718C24.3969 10.1899 25.0724 12.3182 25.0729 14.5ZM15.7083 7.85417V15.1042L15.225 15.4667L10.3917 19.0917L8.94167 17.1583L13.2917 13.8958V7.85417H15.7083Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12_2730">
                    <rect width="29" height="29" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-content-wrapper">
      <div class="inner-wrapper">
        <div class="left-content">
          <div class="top-head-wrapper">
            <!-- <div class="warningWrapper">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <g clip-path="url(#clip0_116_663)">
                    <mask
                      id="mask0_116_663"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="14"
                      height="14"
                    >
                      <path
                        d="M6.99996 12.8333C7.76615 12.8342 8.52496 12.6838 9.23282 12.3906C9.94068 12.0974 10.5836 11.6672 11.1247 11.1247C11.6672 10.5836 12.0974 9.94068 12.3906 9.23282C12.6838 8.52496 12.8342 7.76615 12.8333 6.99996C12.8342 6.23378 12.6838 5.47496 12.3906 4.76711C12.0974 4.05925 11.6672 3.41631 11.1247 2.87521C10.5836 2.33276 9.94068 1.90257 9.23282 1.60936C8.52496 1.31614 7.76615 1.16569 6.99996 1.16663C6.23378 1.16569 5.47496 1.31614 4.76711 1.60936C4.05925 1.90257 3.41631 2.33276 2.87521 2.87521C2.33276 3.41631 1.90257 4.05925 1.60936 4.76711C1.31614 5.47496 1.16569 6.23378 1.16663 6.99996C1.16569 7.76615 1.31614 8.52496 1.60936 9.23282C1.90257 9.94068 2.33276 10.5836 2.87521 11.1247C3.41631 11.6672 4.05925 12.0974 4.76711 12.3906C5.47496 12.6838 6.23378 12.8342 6.99996 12.8333Z"
                        fill="white"
                        stroke="white"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.99992 10.7916C7.19331 10.7916 7.37877 10.7148 7.51552 10.578C7.65226 10.4413 7.72909 10.2558 7.72909 10.0624C7.72909 9.86903 7.65226 9.68356 7.51552 9.54682C7.37877 9.41007 7.19331 9.33325 6.99992 9.33325C6.80653 9.33325 6.62107 9.41007 6.48432 9.54682C6.34757 9.68356 6.27075 9.86903 6.27075 10.0624C6.27075 10.2558 6.34757 10.4413 6.48432 10.578C6.62107 10.7148 6.80653 10.7916 6.99992 10.7916Z"
                        fill="black"
                      />
                      <path
                        d="M7 3.5V8.16667"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </mask>
                    <g mask="url(#mask0_116_663)">
                      <path d="M0 0H14V14H0V0Z" fill="white" />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_116_663">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <span> This is the warning message text </span>
            </div> -->

            <div
              class="selectWrapper"
              *ngIf="taskAssignmentData?.serviceTaskStatus !== 'Completed'"
            >
              <form [formGroup]="changeStatusForm">
                <mat-form-field>
                  <mat-label><h6>Change Status</h6></mat-label>
                  <mat-select
                    (selectionChange)="confirmChange($event)"
                    formControlName="status"
                  >
                    <mat-option value="Pending"
                      ><span>Pending</span>
                    </mat-option>
                    <mat-option value="InProgress"
                      ><span>In Progress</span>
                    </mat-option>
                    <mat-option value="Reopened"
                      ><span>Reopened</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </form>
            </div>
          </div>

          <div class="task-table-wrapper">
            <h3>
              (
              {{
                taskAssignmentData?.serviceTaskData?.taskData?.taskName || "--"
              }}
              ) : {{ taskAssignmentData?.variantName }} -
              {{ taskAssignmentData?.serviceTaskStatus }}
            </h3>

            <div class="tableWrapper">
              <form [formGroup]="tasksForm">
                <table>
                  <thead>
                    <tr>
                      <td></td>
                      <td>Task Name</td>
                    </tr>
                  </thead>
                  <tbody formArrayName="tasks">
                    <tr
                      *ngFor="
                        let task of taskAssignmentData?.serviceTaskData
                          ?.taskData?.taskCheckListItems;
                        let i = index
                      "
                    >
                      <td>
                        <input type="checkbox" [formControlName]="i" />
                      </td>
                      <td>{{ task?.itemName || "--" }}</td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>

          <div class="attachment-Wrapper">
            <div class="attachment-head">
              <h3>Attachment</h3>

              <button
                type="button"
                class="cmn-upload-btn"
                (click)="fileInput.click()"
                [disabled]="fileLoading"
                *ngIf="canUploadOrderFlow$ | async"
              >
                <input
                  #fileInput
                  type="file"
                  (change)="onFileSelected($event)"
                  style="display: none"
                  accept=".pdf, .jpg, .jpeg, .png, .gif, .doc, .docx"
                />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.41675 8.49996C1.41675 4.58783 4.58796 1.41663 8.50008 1.41663C12.4122 1.41663 15.5834 4.58783 15.5834 8.49996C15.5834 12.4121 12.4122 15.5833 8.50008 15.5833C4.58796 15.5833 1.41675 12.4121 1.41675 8.49996ZM8.50008 2.83329C6.99719 2.83329 5.55585 3.43032 4.49314 4.49302C3.43044 5.55573 2.83341 6.99707 2.83341 8.49996C2.83341 10.0029 3.43044 11.4442 4.49314 12.5069C5.55585 13.5696 6.99719 14.1666 8.50008 14.1666C10.003 14.1666 11.4443 13.5696 12.507 12.5069C13.5697 11.4442 14.1667 10.0029 14.1667 8.49996C14.1667 6.99707 13.5697 5.55573 12.507 4.49302C11.4443 3.43032 10.003 2.83329 8.50008 2.83329Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.20833 4.95833C9.20833 4.77047 9.13371 4.5903 9.00087 4.45747C8.86803 4.32463 8.68786 4.25 8.5 4.25C8.31214 4.25 8.13197 4.32463 7.99913 4.45747C7.86629 4.5903 7.79167 4.77047 7.79167 4.95833V7.79167H4.95833C4.77047 7.79167 4.5903 7.86629 4.45747 7.99913C4.32463 8.13197 4.25 8.31214 4.25 8.5C4.25 8.68786 4.32463 8.86803 4.45747 9.00087C4.5903 9.13371 4.77047 9.20833 4.95833 9.20833H7.79167V12.0417C7.79167 12.2295 7.86629 12.4097 7.99913 12.5425C8.13197 12.6754 8.31214 12.75 8.5 12.75C8.68786 12.75 8.86803 12.6754 9.00087 12.5425C9.13371 12.4097 9.20833 12.2295 9.20833 12.0417V9.20833H12.0417C12.2295 9.20833 12.4097 9.13371 12.5425 9.00087C12.6754 8.86803 12.75 8.68786 12.75 8.5C12.75 8.31214 12.6754 8.13197 12.5425 7.99913C12.4097 7.86629 12.2295 7.79167 12.0417 7.79167H9.20833V4.95833Z"
                    fill="white"
                  />
                </svg>

                <h6>Add File</h6>
              </button>
            </div>

            <div class="file-wrapper">
              <!-- <div class="empty-wrapper">
                  <h4>No Attachment</h4>
                </div> -->
              <ng-container *ngIf="attachmentData?.length > 0; else noData">
                <div
                  class="file-item"
                  *ngFor="let attachmentOne of attachmentData"
                >
                  <h6
                    style="cursor: pointer"
                    (click)="viewDocument(attachmentOne?.attachmentUrls)"
                  >
                    {{ attachmentOne?.attachmentUrls?.split("/").pop() }}
                  </h6>

                  <div (click)="confirmRemove(attachmentOne?.id)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_24_3469)">
                        <path
                          d="M7 0.875C3.5875 0.875 0.875 3.5875 0.875 7C0.875 10.4125 3.5875 13.125 7 13.125C10.4125 13.125 13.125 10.4125 13.125 7C13.125 3.5875 10.4125 0.875 7 0.875ZM9.3625 10.0625L7 7.7L4.6375 10.0625L3.9375 9.3625L6.3 7L3.9375 4.6375L4.6375 3.9375L7 6.3L9.3625 3.9375L10.0625 4.6375L7.7 7L10.0625 9.3625L9.3625 10.0625Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_24_3469">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                <div class="file-item" *ngIf="!attachmentData">
                  <h6>{{ attachment?.name }}</h6>
                </div>
              </ng-container>

              <ng-template #noData>
                <div class="empty-wrapper">
                  <h4>No Attachment</h4>
                </div>
              </ng-template>

              <div class="loading-overlay" *ngIf="fileLoading">
                <div class="loading-text">
                  <p>Uploading, please wait</p>
                  <div class="loader"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="activity-Wrapper">
            <div class="activity-head">
              <h3>Activity</h3>

              <button
                (click)="openDialogActivity()"
                *ngIf="canCreateActivityOrderFlow$ | async"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.41675 8.49996C1.41675 4.58783 4.58796 1.41663 8.50008 1.41663C12.4122 1.41663 15.5834 4.58783 15.5834 8.49996C15.5834 12.4121 12.4122 15.5833 8.50008 15.5833C4.58796 15.5833 1.41675 12.4121 1.41675 8.49996ZM8.50008 2.83329C6.99719 2.83329 5.55585 3.43032 4.49314 4.49302C3.43044 5.55573 2.83341 6.99707 2.83341 8.49996C2.83341 10.0029 3.43044 11.4442 4.49314 12.5069C5.55585 13.5696 6.99719 14.1666 8.50008 14.1666C10.003 14.1666 11.4443 13.5696 12.507 12.5069C13.5697 11.4442 14.1667 10.0029 14.1667 8.49996C14.1667 6.99707 13.5697 5.55573 12.507 4.49302C11.4443 3.43032 10.003 2.83329 8.50008 2.83329Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.20833 4.95833C9.20833 4.77047 9.13371 4.5903 9.00087 4.45747C8.86803 4.32463 8.68786 4.25 8.5 4.25C8.31214 4.25 8.13197 4.32463 7.99913 4.45747C7.86629 4.5903 7.79167 4.77047 7.79167 4.95833V7.79167H4.95833C4.77047 7.79167 4.5903 7.86629 4.45747 7.99913C4.32463 8.13197 4.25 8.31214 4.25 8.5C4.25 8.68786 4.32463 8.86803 4.45747 9.00087C4.5903 9.13371 4.77047 9.20833 4.95833 9.20833H7.79167V12.0417C7.79167 12.2295 7.86629 12.4097 7.99913 12.5425C8.13197 12.6754 8.31214 12.75 8.5 12.75C8.68786 12.75 8.86803 12.6754 9.00087 12.5425C9.13371 12.4097 9.20833 12.2295 9.20833 12.0417V9.20833H12.0417C12.2295 9.20833 12.4097 9.13371 12.5425 9.00087C12.6754 8.86803 12.75 8.68786 12.75 8.5C12.75 8.31214 12.6754 8.13197 12.5425 7.99913C12.4097 7.86629 12.2295 7.79167 12.0417 7.79167H9.20833V4.95833Z"
                    fill="white"
                  />
                </svg>

                <h6>Add Activity</h6>
              </button>
            </div>

            <div class="tableWrapper">
              <table>
                <thead>
                  <tr>
                    <td>Activity Type</td>
                    <td>Message</td>
                  </tr>
                </thead>
                <tbody *ngIf="taskTimelineData?.length > 0; else noData">
                  <tr *ngFor="let taskTimelineData of taskTimelineData">
                    <td>
                      {{
                        formatActionType(taskTimelineData?.actionType) || "--"
                      }}
                    </td>
                    <td>{{ taskTimelineData?.message || "--" }}</td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="2">No activity found</td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="chat-wrapper">
            <div class="headWrapper">
              <h3>Notes</h3>
            </div>
            <div class="chat-content">
              <div class="chat-item" *ngFor="let note of notesData">
                <h6>
                  {{
                    note?.actorData?.firstName +
                      " " +
                      note?.actorData?.lastName || "Unknown"
                  }}
                  : {{ note?.message }}
                </h6>
                <h5>{{ note?.createdAt | date : "MMMM d YYYY, h:mm a" }}</h5>
              </div>
            </div>
            <form [formGroup]="addNoteForm">
              <div class="text-wrapper" *ngIf="canSendNoteOrderFlow$ | async">
                <div>
                  <input
                    type="text"
                    placeholder="add notes here!"
                    formControlName="message"
                  />
                  <div (click)="addNote()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="37"
                      viewBox="0 0 37 37"
                      fill="none"
                    >
                      <rect width="37" height="37" rx="5" fill="#0822C5" />
                      <path
                        d="M17.1947 19.8053L25 12M17.1947 19.8053L19.6782 24.7723C19.7093 24.8403 19.7593 24.8978 19.8222 24.9382C19.8851 24.9785 19.9583 25 20.033 25C20.1077 25 20.1809 24.9785 20.2438 24.9382C20.3067 24.8978 20.3566 24.8403 20.3878 24.7723L25 12M17.1947 19.8053L12.2277 17.3218C12.1597 17.2907 12.1022 17.2407 12.0618 17.1778C12.0215 17.1149 12 17.0417 12 16.967C12 16.8923 12.0215 16.8191 12.0618 16.7562C12.1022 16.6933 12.1597 16.6434 12.2277 16.6122L25 12"
                        stroke="white"
                        stroke-width="1.41915"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="btnWrapper"
      *ngIf="
        (allTasksChecked() &&
        taskAssignmentData?.serviceTaskStatus !== 'Completed' &&
        taskAssignmentData?.serviceTaskStatus !== 'Review' ) || taskAssignmentData.length === 0
      "
    > -->
    <div
      class="btnWrapper"
      *ngIf="
        (taskAssignmentData?.serviceTaskData?.taskData?.taskCheckListItems
          .length === 0 &&
          taskAssignmentData?.serviceTaskStatus !== 'Completed' &&
          taskAssignmentData?.serviceTaskStatus !== 'Review') ||
        (allTasksChecked() &&
          taskAssignmentData?.serviceTaskStatus !== 'Completed' &&
          taskAssignmentData?.serviceTaskStatus !== 'Review')
      "
    >
      <button class="cmn-add-btn" (click)="markAsCompleted()">
        Mark As Complete
      </button>
    </div>
  </div>
</section>
